import * as React from "react";
const SvgMenu20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 12,
        fill: "black",
        viewBox: "0 0 16 12"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M1 0H0v2h16V0H1ZM0 5h16v2H0V5Zm0 5h16v2H0v-2Z",
      clipRule: "evenodd"
    })
  );
export default SvgMenu20Px;
